// Module
var code = "<div class=\"trainRoster container\">\r\n    <div class=\"title\">Manage Trains</div>\r\n    <div data-id=\"trains\" class=\"trains pageContent\"></div>\r\n    <div class=\"buttons\"><button data-id=\"new\">New...</button></div>\r\n</div>";
// Exports
export default code;